import { Link, NavLink } from "react-router-dom";
import { Wind, Menu, X } from "lucide-react";
import { useState } from "react";

export default function Header() {
  const [open, setOpen] = useState(false);

  const links = [
    { to: "/services", label: "Services" },
    { to: "/packages", label: "Packages" },
    { to: "/service-areas", label: "Service Areas" },
    { to: "/about", label: "About" },
    { to: "/contact", label: "Contact" },
  ];

  return (
    <header className="glass-header sticky top-0 z-50" data-testid="site-header">
      <div className="max-w-7xl mx-auto px-6 md:px-10 h-16 flex items-center justify-between">
        <Link to="/" className="flex items-center gap-2 group" data-testid="logo-link">
          <span className="inline-flex w-9 h-9 rounded-full bg-forest text-white items-center justify-center">
            <Wind size={18} strokeWidth={1.75} />
          </span>
          <div className="leading-tight">
            <div className="font-heading text-[15px] font-medium tracking-tight text-ink">Full Indoor Air</div>
            <div className="text-[10px] uppercase tracking-[0.22em] text-forest-soft">MD · DC · VA</div>
          </div>
        </Link>

        <nav className="hidden md:flex items-center gap-8" aria-label="Primary">
          {links.map((l) => (
            <NavLink
              key={l.to}
              to={l.to}
              data-testid={`nav-${l.label.toLowerCase().replace(/\s+/g, "-")}`}
              className={({ isActive }) =>
                `text-sm tracking-tight transition-colors hover:text-forest ${
                  isActive ? "text-forest font-medium" : "text-ink/75"
                }`
              }
            >
              {l.label}
            </NavLink>
          ))}
        </nav>

        <div className="hidden md:flex">
          <Link to="/book" className="btn-primary text-sm" data-testid="header-book-cta">
            Book Now
          </Link>
        </div>

        <button
          className="md:hidden p-2 rounded-full border border-black/10"
          onClick={() => setOpen(!open)}
          aria-label="Toggle menu"
          data-testid="mobile-menu-toggle"
        >
          {open ? <X size={18} /> : <Menu size={18} />}
        </button>
      </div>

      {open && (
        <div className="md:hidden border-t border-black/5 bg-bone/95 backdrop-blur" data-testid="mobile-menu">
          <div className="px-6 py-4 flex flex-col gap-3">
            {links.map((l) => (
              <NavLink
                key={l.to}
                to={l.to}
                onClick={() => setOpen(false)}
                className="text-base py-2 text-ink/85 hover:text-forest"
                data-testid={`mobile-nav-${l.label.toLowerCase().replace(/\s+/g, "-")}`}
              >
                {l.label}
              </NavLink>
            ))}
            <Link
              to="/book"
              onClick={() => setOpen(false)}
              className="btn-primary justify-center mt-2"
              data-testid="mobile-book-cta"
            >
              Book Now
            </Link>
          </div>
        </div>
      )}
    </header>
  );
}
